import isPropValid from '@emotion/is-prop-valid';
import { VALID_STYLED_SYSTEM_PROPS } from "./constants";

var toMap = function toMap(arrayOfStrings) {
  return new Map(arrayOfStrings.map(function (key) {
    return [key, true];
  }));
};

var styledSystemProps = toMap(VALID_STYLED_SYSTEM_PROPS);

var omitProps = function omitProps() {
  var customPropsList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$omitStyledSystem = _ref.omitStyledSystemProps,
      omitStyledSystemProps = _ref$omitStyledSystem === void 0 ? true : _ref$omitStyledSystem;

  var shouldForwardProp = function shouldForwardProp(prop) {
    if (!omitStyledSystemProps && prop === 'as') {
      return true;
    }

    return isPropValid(prop) && !customPropsList.includes(prop) && !(omitStyledSystemProps && styledSystemProps.has(prop));
  };

  return {
    shouldForwardProp: shouldForwardProp
  };
};

export default omitProps;